export default "__VITE_ASSET__6e0e27d5__"